import LocationIcon from 'Images/SVG/Location.svg'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { Box, FlexRowDiv, H3, P } from 'components/generic/HomePageComponents'
import { ProfileImage, StyledProfileCard } from './Styled'

const ProfileCard = ({
  card: {
    name,
    lastSeenInWords,
    path,
    city: { name: cityName },
    country: { name: countryName },
    user: {
      avatar: { large_url },
      full_name,
    },
  },
  display,
}) => (
  <StyledProfileCard href={path} display={display}>
    <ProfileImage src={large_url} width='225px' height='225px' />
    <FlexRowDiv flexDirection='column' p='25px 25px 0 25px' justifyContent='flex-start'>
      <H3 fontWeight='bold' lineHeight='1' mb='5px' mt='0px' textAlign='left' maxWidth='200px'>
        {full_name}
      </H3>
      <P width='175px' fontSize='18px' mb='10px' mt='0px' lineHeight='1.13'>
        {name}
      </P>
      <Box display='flex'>
        <GenericLazyLoadImage src={LocationIcon} height='12px' pr='6px' pb='8px' />
        <P fontSize='1' mb='5px' mt='0px' fontWeight='400'>{`${cityName}, ${countryName}`}</P>
      </Box>
      <P fontSize='1' fontWeight='400'>
        {lastSeenInWords}
      </P>
    </FlexRowDiv>
  </StyledProfileCard>
)

export default ProfileCard
